/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Table_Col_BoatsInputs */

const es_marketplace_seo_license_table_col_boats = /** @type {(inputs: Marketplace_Seo_License_Table_Col_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embarcaciones`)
};

const gl_marketplace_seo_license_table_col_boats = /** @type {(inputs: Marketplace_Seo_License_Table_Col_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embarcacións`)
};

const en_marketplace_seo_license_table_col_boats = /** @type {(inputs: Marketplace_Seo_License_Table_Col_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vessels`)
};

/**
* | output |
* | --- |
* | "Vessels" |
*
* @param {Marketplace_Seo_License_Table_Col_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_table_col_boats = /** @type {((inputs?: Marketplace_Seo_License_Table_Col_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Table_Col_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_table_col_boats(inputs)
	if (locale === "en") return en_marketplace_seo_license_table_col_boats(inputs)
	return es_marketplace_seo_license_table_col_boats(inputs)
});